module.exports = __webpack_public_path__ + "img/caio-monteiro-cerberifight.5e7daf64.jpg";